import useSWR from "swr";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { BonificoOrderDTO } from "./BonificoOrderDTO.ts";
import {
  BonificoOrdersListQuery,
  toBonificoOrdersApiParams,
} from "./BonificoOrdersListQuery.ts";

export function useBonificoOrdersPage(query: BonificoOrdersListQuery) {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const params = toBonificoOrdersApiParams(query);

  const { data, error, isLoading, mutate } = useSWR(
    ["/bonifico-orders", JSON.stringify(params)],
    async () => {
      const { data } = await createAxiosInstance().get<{
        orders: BonificoOrderDTO[];
        totalCount: number;
      }>("/bonifico-orders", { params });
      return data;
    },
    { keepPreviousData: true },
  );

  return {
    orders: data?.orders ?? [],
    totalCount: data?.totalCount ?? 0,
    error,
    isLoading: isLoading && data === undefined,
    refetch: mutate,
  };
}
